module["exports"] = [
  "straat",
  "laan",
  "weg",
  "plantsoen",
  "park"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nl/address/street_suffix.js
// module id = 2550
// module chunks = 2